/**
* Trigger predictive search overlay from Search result page
*/

const searchPageInput = document.getElementById('Search-In-Template');
const headerSearchModal = document.querySelector('.header__search');
let predictiveSearchInput;

// Function to synchronize text between inputs
function synchronizeText(sourceInput, targetInput) {
  targetInput.value = sourceInput.value;
}

// Add a click event listener to the searchPageInput element
searchPageInput.addEventListener('click', function() {
  if (headerSearchModal) {
    const predictiveSearchDetails = headerSearchModal.querySelector('details') ;

    if (predictiveSearchDetails) {
      predictiveSearchDetails.setAttribute('open', 'true');
      predictiveSearchInput = headerSearchModal.querySelector('#Search-In-Modal-1');
      if (predictiveSearchInput) {
        predictiveSearchInput.value = searchPageInput.value;
        predictiveSearchInput.focus();
      }
    }
  }
});

// Add event listener to search input to update target input
searchPageInput.addEventListener('input', function() {
  if (predictiveSearchInput) {
    synchronizeText(searchPageInput, predictiveSearchInput);
  }
});

// Add event listener to target input to update search input
if (headerSearchModal) {
  headerSearchModal.addEventListener('input', function() {
    if (predictiveSearchInput) {
      synchronizeText(predictiveSearchInput, searchPageInput);
    }
  });
}